import src from "IMAGE";
export default { src, width: 348, height: 145, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAOklEQVR42k3LMQrAIABD0bQUSqt4AyddRVfvfzG/kMHhkWSIJD148R154zJlDHRUTDTvIr+C7R4t4V9SQwHVmncijgAAAABJRU5ErkJggg=="};
